module.exports = __webpack_public_path__ + "img/residence.e496b765.svg";